<template>
  <img
    class="shadowed"
    src="@/assets/images/code_and_magic_black_textlogo.svg"
    alt="Code & Magic"
    width="auto"
    height="auto"
    fetchpriority="high"
    decoding="async"
  >
</template>

<style scoped>
.shadowed {
    margin: 6px;
    filter: invert(1) drop-shadow(#000000 0 0 4px);
}
</style>
